import React from 'react';
import './shared.css';

/**
 * Efftabs-branded loading overlay.
 * 4 colored blocks (green, blue, red, yellow) rotate like the logo palette.
 * Usage: {loading && <LoadingOverlay />}
 * Optional: <LoadingOverlay text="Fetching data..." />
 */
const LoadingOverlay = ({ text = 'Loading...' }) => (
    <div className="pg-loading-overlay">
        <div className="pg-loading-card">
            <div className="pg-logo-loader">
                <div className="pg-logo-block pg-block-green"  />
                <div className="pg-logo-block pg-block-blue"   />
                <div className="pg-logo-block pg-block-red"    />
                <div className="pg-logo-block pg-block-yellow" />
            </div>
            <p className="pg-loading-text">{text}</p>
        </div>
    </div>
);

export default LoadingOverlay;
